import { message } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { DBAction } from "../../../enum/DBAction";
import { StoreState } from "../../../enum/StoreState";
import { useStores } from "../../../stores/setup/use-store";
import OperationRuleLocationInsightModal from "./OperationRuleLocationInsightModal";

import "video-react/dist/video-react.css";
import {
  Box,
  Select,
  Button,
  Flex,
  useDisclosure,
  FormLabel,
  Alert,
  AlertIcon,
  useToast,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { IOperationRuleLocation } from "../../../stores/data/operationRuleLocations/OperationRuleLocationModel";
import noInsights from "../../../assets/noInsights.svg";
import EmptyState from "../../../components/EmptyState/EmptyState";
import { IOperationRuleLocationItem } from "../../../stores/data/operationRuleLocationInsights/operationRuleLocationInsightModel";
import { AlertDelete } from "../../../components/AlertDelete/AlertDelete";
import Loading from "../../../components/Loading/Loading";
import i18n from "i18n";
import DraggableTable from "components/DraggableTable";

const OperationRuleLocationInsightDetail: React.FC = () => {
  const {
    dataStores: {
      operationRuleLocationInsightStore,
      operationRuleLocationStore,
      oceanWeatherIntelligenceStore,
      operationRuleStore,
      authStore,
    },
  } = useStores();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();
  const toast = useToast();
  const history = useHistory();

  const { t } = useTranslation("translation", {
    keyPrefix: "oceanWeatherIntelligence.operationRuleLocationInsight",
  });

  const [selectedStation] = useState(
    operationRuleLocationStore.operationRuleLocationMainId
  );
  const [location, setLocation] = useState<IOperationRuleLocation>();
  const [insightRemove, setInsightRemove] =
    useState<IOperationRuleLocationItem | null>(null);

  useEffect(() => {
    if (
      operationRuleStore.operationRuleMainId > 0 &&
      (selectedStation !==
        operationRuleLocationStore.operationRuleLocationMainId ||
        operationRuleLocationStore.operationRuleLocations.length === 0)
    ) {
      operationRuleLocationStore.getOperationRuleLocationsApi(
        operationRuleStore.operationRuleMainId
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operationRuleStore.operationRuleMainId]);

  useEffect(() => {
    if (operationRuleLocationStore.operationRuleLocationMainId) {
      operationRuleLocationInsightStore.getOperationRuleLocationInsightApi(
        operationRuleLocationStore.operationRuleLocationMainId
      );

      const location = operationRuleLocationStore.getOperationRuleLocation(
        operationRuleLocationStore.operationRuleLocationMainId
      );

      setLocation(location);
      if (location) {
        oceanWeatherIntelligenceStore.getEnvironmentalVariableForStationAPI(
          location.stationId || 0,
          location.macroRegionId || 0
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    operationRuleLocationStore.operationRuleLocations,
    operationRuleLocationStore.actionCallInsightsList,
  ]);

  const handleSelectLocationChange = (value: number) => {
    if (value > 0) {
      operationRuleLocationStore.setOperationRuleLocationMainId(value);
      operationRuleLocationInsightStore.getOperationRuleLocationInsightApi(
        value
      );
      const locationSeletected =
        operationRuleLocationStore.getOperationRuleLocation(value);
      setLocation(locationSeletected);
      if (locationSeletected) {
        oceanWeatherIntelligenceStore.getEnvironmentalVariableForStationAPI(
          locationSeletected.stationId || 0,
          locationSeletected.macroRegionId || 0
        );
      }
    }
  };

  const handleOnEdit = (value: any) => {
    if (
      !operationRuleLocationStore.operationRuleLocationMainId ||
      operationRuleLocationStore.operationRuleLocationMainId <= 0
    ) {
      message.info(t("youNeedSelectLocationToEditInsight"));
    } else {
      operationRuleLocationInsightStore.setOperationRuleLocationItem(value);
      operationRuleLocationInsightStore.setOperationRuleLocationItemAction(
        DBAction.UPDATE
      );
      oceanWeatherIntelligenceStore.setChangeForUpdate({
        update: true,
        expiration: 0,
      });
      onOpen();
    }
  };

  const handleOnConfirmDelete = () => {
    const insightId = insightRemove?.id;
    if (insightId && insightId > 0) {
      operationRuleLocationInsightStore
        .deleteOperationRuleLocationInsight(insightId)
        .then((success) => {
          if (success) {
            if (
              !operationRuleLocationInsightStore.operationRuleLocationItens
                ?.length
            ) {
              operationRuleLocationInsightStore.setHasInsights(false);
            } else {
              operationRuleLocationInsightStore.setHasInsights(false);
            }
          }
        });
      oceanWeatherIntelligenceStore.setChangeForUpdate({
        update: true,
        expiration: 0,
      });
      setInsightRemove(null);
      onDeleteClose();
    } else {
      message.error(t("locationRemovalFailedContactUs"));
    }
  };

  const handleCreateInsight = () => {
    if (
      !operationRuleLocationStore.operationRuleLocationMainId ||
      operationRuleLocationStore.operationRuleLocationMainId <= 0
    ) {
      message.info(t("youNeedSelectLocationToAddInsight"));
    } else {
      operationRuleLocationInsightStore.setActionCallCreateInsight();
      operationRuleLocationInsightStore.setOperationRuleLocationItemAction(
        DBAction.CREATE
      );
      oceanWeatherIntelligenceStore.setChangeForUpdate({
        update: true,
        expiration: 0,
      });
      onOpen();
    }
  };

  const handleOpenDeleteModal = (insight: IOperationRuleLocationItem) => {
    setInsightRemove(insight);
    onDeleteOpen();
  };

  return (
    <Box>
      {operationRuleLocationInsightStore.state === StoreState.ERROR && (
        <Alert status="error" mb={4} color="black">
          <AlertIcon />
          {operationRuleLocationInsightStore.messageError}
        </Alert>
      )}
      {authStore.readOnlyUser && (
        <Alert bg="#bee3f8" status="info" mb={4} color="gray.700">
          <AlertIcon />
          {i18n.t("readingModePleaseContact")}
        </Alert>
      )}

      {location && (
        <OperationRuleLocationInsightModal
          location={location}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}

      <>
        {operationRuleLocationInsightStore.state === StoreState.PEDDING && (
          <Loading />
        )}

        <AlertDelete
          isOpen={isDeleteOpen}
          onClose={onDeleteClose}
          titleLabel={t("deleteInsight")}
          bodyText={t("areYouSureCantUndoThis", {
            insightName: insightRemove?.name,
          })}
          cancelButtonLabel={t("cancel")}
          deleteButtonLabel={t("delete")}
          handleDelete={handleOnConfirmDelete}
        />

        <Flex>
          <Box>
            <FormLabel color={"newBlue.500"}>{t("selectLocation")}</FormLabel>
            <Select
              w={"260px"}
              borderRadius={8}
              color={"blue.100"}
              backgroundColor="#ffffff"
              size="md"
              key={`SelectLocation-${operationRuleLocationStore.operationRuleLocationMainId}`}
              onChange={(e) =>
                handleSelectLocationChange(parseInt(e.target.value))
              }
              value={operationRuleLocationStore.operationRuleLocationMainId}
              _hover={{ borderColor: "blue.100" }}
              _focus={{ borderColor: "none" }}
            >
              {operationRuleLocationStore.operationRuleLocations.map(
                (value) => (
                  <option
                    style={{ color: "black" }}
                    value={value.id}
                    key={value.id}
                  >
                    {value.name}
                  </option>
                )
              )}
            </Select>
          </Box>
          {!authStore.readOnlyUser && (
            <Button
              mt={8}
              ml={4}
              layerStyle="ocean"
              _hover={{ layerStyle: "ocean" }}
              leftIcon={<AddIcon />}
              onClick={handleCreateInsight}
            >
              {t("addNewInsight")}
            </Button>
          )}
        </Flex>

        {operationRuleLocationInsightStore.operationRuleLocationItens?.some(
          (item) => item.isProcessing
        ) && (
          <Alert
            mt={4}
            borderRadius="6px"
            bg="#FDF1CC"
            color="#987405"
            border="none"
          >
            <AlertIcon color="#987405" />
            <Text>{t("insightsProcessing")}</Text>
          </Alert>
        )}

        {operationRuleLocationInsightStore.operationRuleLocationItens?.length >
          0 && (
          <DraggableTable
            data={operationRuleLocationInsightStore.operationRuleLocationItens}
            columns={[
              {
                key: "name",
                header: t("name"),
                width: "70%",
                render: (value: string, item: IOperationRuleLocationItem) => (
                  <Flex alignItems="center" gap={2}>
                    <span>{value}</span>
                    {item.isProcessing && (
                      <Box
                        as="span"
                        px={2}
                        py={0.5}
                        borderRadius="4px"
                        bg="rgba(152, 116, 5, 0.1)"
                        color="#987405"
                        fontSize="14px"
                        fontWeight="500"
                        lineHeight="20px"
                      >
                        {i18n.t("oceanWeatherIntelligence.processing")}
                      </Box>
                    )}
                  </Flex>
                ),
              },
              {
                key: "operationRuleAlerts",
                header: t("registeredAlerts"),
                width: "30%",
                render: (
                  _value: unknown,
                  item: IOperationRuleLocationItem
                ) => (
                  <Flex justifyContent="center" alignItems="center">
                    {item.operationRuleAlerts &&
                    item.operationRuleAlerts.length > 0 ? (
                      <Tooltip
                        hasArrow
                        placement="top"
                        label={item.operationRuleAlerts
                          .map((alert) => alert.name)
                          .join("\n")}
                        whiteSpace="pre-line"
                      >
                        <Flex
                          alignItems="center"
                          gap={1}
                          color="#1E5297"
                          fontSize="14px"
                          cursor="pointer"
                          _hover={{
                            textDecoration: "underline",
                          }}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            history.push(
                              `/insight-alerts?operationRuleLocationItemIds=${item.id}`
                            );
                          }}
                        >
                          <Text>
                            {item.operationRuleAlerts.length === 1
                              ? t("oneAlert")
                              : `${item.operationRuleAlerts.length} ${t(
                                  "multipleAlerts"
                                )}`}
                          </Text>
                          <ChevronRightIcon
                            style={{ fontSize: "18px", marginBottom: "3px" }}
                          />
                        </Flex>
                      </Tooltip>
                    ) : (
                      <Text color="gray.400" fontSize="14px">
                        -
                      </Text>
                    )}
                  </Flex>
                ),
              },
            ]}
            onEdit={handleOnEdit}
            onDelete={handleOpenDeleteModal}
            showDeleteButton={!authStore.readOnlyUser}
            disableDragAndDrop={!authStore.adminUser}
            tableStyle={{
              color: "#71717A",
              backgroundColor: "#FAFAFA",
              marginTop: "10px",
            }}
            rowStyle={{
              backgroundColor: "white",
              borderColor: "rgba(30, 82, 151, 0.12)",
              color: "newBlue.500",
              height: "56px",
            }}
            dragStyle={{
              backgroundColor: "#D8E7F0",
            }}
            onSaveOrder={(newData) => {
              let locationId: number | undefined;

              if (newData.length) {
                locationId = newData[0].operationRuleLocationId;

                operationRuleLocationInsightStore.setOperationRuleLocationItens(
                  newData
                );
              }

              if (locationId) {
                const ids = newData.map(
                  (item: IOperationRuleLocationItem) => item.id
                );

                operationRuleLocationInsightStore.updateOperationRuleLocationItemOrder(
                  {
                    locationId,
                    idsInOrder: ids,
                  }
                );

                oceanWeatherIntelligenceStore.setChangeForUpdate({
                  update: true,
                  expiration: 0,
                });
              } else {
                toast({
                  title: i18n.t(
                    "oceanWeatherIntelligence.oceanWeatherIntelligence.errorWhileSaveSort"
                  ),
                  status: "error",
                  position: "top",
                  isClosable: true,
                });
              }
            }}
          />
        )}
      </>

      {!operationRuleLocationInsightStore.operationRuleLocationItens?.length &&
        !operationRuleLocationInsightStore.hasInsights && (
          <EmptyState
            description={t("weReAlmostTheNowRegisterInsight")}
            image={noInsights}
            imageSize="26vw"
            buttonAction={handleCreateInsight}
            buttonIcon={<AddIcon />}
            buttonText={
              !authStore.readOnlyUser
                ? (t("addNewInsight") as string)
                : undefined
            }
            marginTop={"6"}
          />
        )}
    </Box>
  );
};

export default observer(OperationRuleLocationInsightDetail);
